import { render, staticRenderFns } from "./CardComponent.vue?vue&type=template&id=6983386c&"
import script from "./CardComponent.vue?vue&type=script&lang=js&"
export * from "./CardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports